// extracted by css-extract-rspack-plugin
export default {"root":"styles_root__bcg47","bookingAssistance":"styles_bookingAssistance__qnzbj","bookingAssistanceTitle":"styles_bookingAssistanceTitle__Q+dlN"};